import { BanIcon, CircleAlert, CircleCheck, Info } from "lucide-react";
import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="toaster group"
      expand
      pauseWhenPageIsHidden
      position="bottom-center"
      visibleToasts={3}
      icons={{
        error: <BanIcon />,
        success: <CircleCheck />,
        warning: <CircleAlert />,
        info: <Info />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:border-l-[10px] group-[.toaster]:shadow-none group-[.toaster]:p-[15px] rounded-lg",
          info: "group-[.toaster]:bg-info-muted [&_.title]:text-info [&_.icon]:text-info [&_.closeButton]:text-info group-[.toaster]:text-foreground group-[.toaster]:border-info ",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success:
            "group-[.toaster]:bg-success-muted [&_.title]:text-success [&_.icon]:text-success [&_.closeButton]:text-success group-[.toaster]:border-success",
          error:
            "group-[.toaster]:bg-destructive-muted [&_.title]:text-destructive [&_.icon]:text-destructive [&_.closeButton]:text-destructive group-[.toaster]:border-destructive",
          warning:
            "group-[.toaster]:bg-warning-muted [&_.title]:text-warning [&_.icon]:text-warning [&_.closeButton]:text-warning group-[.toaster]:border-warning",
          title: "group title text-lg leading-none font-bold",
          closeButton:
            "closeButton right-0 left-auto top-4 h-6 w-6 border-none group-[.toaster]:hover:hover:bg-transparent group-[.toaster]:hover:hover:border-none [&>svg]:h-5 [&>svg]:w-5",
          icon: "icon w-10 h-10 [&>svg]:w-full [&>svg]:h-full",
        },
        closeButton: true,
      }}
      {...props}
    />
  );
};

export { Toaster };
